[
  {
    "code": "KE-200",
    "name": "Central"
  },
  {
    "code": "KE-300",
    "name": "Coast"
  },
  {
    "code": "KE-400",
    "name": "Eastern"
  },
  {
    "code": "KE-110",
    "name": "Nairobi"
  },
  {
    "code": "KE-500",
    "name": "North-Eastern"
  },
  {
    "code": "KE-600",
    "name": "Nyanza"
  },
  {
    "code": "KE-700",
    "name": "Rift Valley"
  },
  {
    "code": "KE-800",
    "name": "Western"
  }
]